export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oferty"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Moje transakcje"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Moje ogłoszenia"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transakcje"])}
}